import { brands, BrandType } from 'noddi-types';

import { NoddiLogo } from 'noddi-ui-web';
import bestDriveLogo from '../../assets/images/bestdrive/bestdrive-logo.png';
import DekkfixLogo from '../../assets/images/dekkfix/dekkfix-logo.png';
import dekkstraLogo from '../../assets/images/dekkstra/dekkstra-logo.png';
import dekkteamLogo from '../../assets/images/dekkteam/dekkteam-logo.png';
import EliteBilvaskLogo from '../../assets/images/elitebilvask/elitebilvask-logo.png';
import lotusLogo from '../../assets/images/lotus/lotus-logo.png';
import meksLogo from '../../assets/images/meks/meks-logo.png';
import myldreLogo from '../../assets/images/myldre/myldre-logo.png';
import shineLogo from '../../assets/images/shine/shine-logo.png';
import tronderdekkLogo from '../../assets/images/tronderdekk/tronderdekk-logo.png';
import CarglassLogo from '../../assets/svg/hurtigRuta';

export function getBrandLogo({ brand, noddiColor }: { brand: BrandType; noddiColor?: string }) {
  switch (brand) {
    case brands.noddi:
      return <NoddiLogo color={noddiColor} width={67} height={19} />;
    case brands.bestdrive:
      return <img src={bestDriveLogo} alt='brand logo' className='w-[82px]' />;
    case brands.tronderdekk:
      return <img src={tronderdekkLogo} alt='brand logo' className='w-[82px]' />;
    case brands.carglass:
      return <CarglassLogo scale={0.8} />;
    case brands.dekkstra:
      return <img src={dekkstraLogo} alt='brand logo' className='w-8 rounded-full' />;
    case brands.dekkfix:
      return <img src={DekkfixLogo} alt='brand logo' className='w-[82px]' />;
    case brands.elitebilvask:
      // Logo will be added later
      return <img src={EliteBilvaskLogo} alt='brand logo' className='w-15' />;
    case brands.dekkteam:
      return <img src={dekkteamLogo} alt='brand logo' className='w-[82px]' />;
    case brands.shine:
      return <img src={shineLogo} alt='brand logo' className='w-[82px]' />;
    case brands.lotus:
      return <img src={lotusLogo} alt='brand logo' className='w-10 rounded-full' />;
    case brands.myldre:
      return <img src={myldreLogo} alt='brand logo' className='w-[82px]' />;
    case brands.meks:
      return <img src={meksLogo} alt='brand logo' className='w-[82px]' />;
    default:
      return null;
  }
}
